// extracted by mini-css-extract-plugin
var _1 = "ReorderableList-module__draggableContainer--eu8Ej";
var _2 = "ReorderableList-module__orderContainer--tpPRs";
export { _1 as "draggableContainer", _2 as "orderContainer" }
